
export const NodeMap = {
    heco: "https://http-mainnet-node.huobichain.com",
    bsc: "https://bsc-dataseed3.defibit.io",
    eth: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
    polygon: "https://polygon-rpc.com",
    ftm: 'https://rpc.ftm.tools',
    hsc: 'https://http-mainnet.hoosmartchain.com',
    bsctest: 'https://data-seed-prebsc-1-s1.binance.org:8545'
};

export const NativeSymbolMap = {
    bsctest: 'tBNB',
    heco: 'HT',
    bsc: 'BNB',
    eth: 'ETH',
    polygon: 'MATIC',
    ftm: 'FTM',
    hsc: 'HOO'
}

export const MulticallContractMap = {
    'bsctest': '0x3DCDb973fC7511325a5311381aA611C51595294D',
    'eth': '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
    "heco": '0x91258C01987e4364923DB22bf8D1f5fe16d0Ef67',
    "bsc": '0xc5d9B4142DE66A88b0655aCB56393Dcf24d0Abc1',
    "polygon": '0xcac0c6f4d091f38550bde307dce52187b370a85e',
    "ftm": '0x517B6d39C85811d62299b9eEF6CF3618507e03C8',
    "hsc": '0x88E84a79b4302145480BC9FD6fAF2709c18FDb23'
}

export const ContractMap = {
    // 'bsctest': '0xdf9D254665680Fe85602DB5d42b4da1C0e6e9F94',
    "heco": '0x749ca2666D20d659c25952f8FAa249eC5Ae72189',
    "bsc": '0x749ca2666D20d659c25952f8FAa249eC5Ae72189',
    "polygon": '0x749ca2666D20d659c25952f8FAa249eC5Ae72189',
    "ftm": '0x749ca2666D20d659c25952f8FAa249eC5Ae72189',
}


export const ChainIdMap = {
    heco: 128,
    bsc: 56,
    eth: 1,
    polygon: 137,
    ftm: 250,
    hsc: 70,
    bsctest: 97
};

export const IdChainMap = {
    128: 'heco',
    56: 'bsc',
    137: 'polygon',
    1: 'eth',
    250: 'ftm',
    97: 'bsctest',
    70: 'hsc'
}


export const DesignList = [
    {
        "twitter": "https://twitter.com/LinPende",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 1,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x4e54b68981edd294a09b442f065a7c6083bb768b/bsc",
        "descEn": "A special design for TokenPocket Event.",
        "descZh": "给TokenPocket的特别创作。",
        "titleZh": "BitSpace",
        "titleEn": "BitSpace",
        "nfts": [
            {
                "type": 1,
                "id": 3,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/3.png"
            },
            {
                "type": 2,
                "id": 2,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/2.png"
            },
            {
                "type": 3,
                "id": 1,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/1.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/Bong29279628",
        "viewAll": false,
        "layout": "full",
        "bgColor": "#000000",
        "group": 2,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x44ee8d80df81b5aacb3280f7e576bceae919eef2/bsc",
        "descEn": "EtherStar",
        "descZh": "EtherStar",
        "titleZh": "EtherStar",
        "titleEn": "EtherStar",
        "nfts": [
            {
                "type": 1,
                "id": 6,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/6.png"
            },
            {
                "type": 2,
                "id": 5,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/5.png"
            },
            {
                "type": 3,
                "id": 4,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/4.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/Bong29279628",
        "viewAll": false,
        "layout": "full",
        "bgColor": "#000000",
        "group": 3,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x44ee8d80df81b5aacb3280f7e576bceae919eef2/bsc",
        "descEn": "-",
        "descZh": "-",
        "titleZh": "Under the SUN",
        "titleEn": "Under the SUN",
        "nfts": [
            {
                "type": 1,
                "id": 9,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/9.png"
            },
            {
                "type": 2,
                "id": 8,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/8.png"
            },
            {
                "type": 3,
                "id": 7,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/7.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/Sammvioo",
        "viewAll": false,
        "layout": "full",
        "bgColor": "#000000",
        "group": 4,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xa25c075e971fadeb266d6f24ffc7864d476a9624/bsc",
        "descEn": "Flowers in the sun.",
        "descZh": "阳光下的花。",
        "titleZh": "花",
        "titleEn": "Flowers",
        "nfts": [
            {
                "type": 1,
                "id": 12,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/12.png"
            },
            {
                "type": 2,
                "id": 10,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/10.png"
            },
            {
                "type": 3,
                "id": 11,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/11.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/chunyuhuajia1",
        "viewAll": false,
        "layout": "full",
        "bgColor": "#000000",
        "group": 5,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x73c807e5eda257f86f689abcd5820527d9bf94f8/bsc",
        "descEn": "Jump out of range and into the world!",
        "descZh": "跳出范围，跳进世界！",
        "titleZh": "跃",
        "titleEn": "JUMP",
        "nfts": [
            {
                "type": 1,
                "id": 15,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/15.jpg"
            },
            {
                "type": 2,
                "id": 13,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/13.jpg"
            },
            {
                "type": 3,
                "id": 14,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/14.jpg"
            },


        ]
    },
    {
        "twitter": "https://twitter.com/LinPende",
        "viewAll": false,
        "layout": "full",
        "bgColor": "#000000",
        "group": 6,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x4e54b68981edd294a09b442f065a7c6083bb768b/bsc",
        "descEn": "-",
        "descZh": "-",
        "titleZh": "Rising rings",
        "titleEn": "Rising rings",
        "nfts": [
            {
                "type": 1,
                "id": 18,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/18.png"
            },
            {
                "type": 2,
                "id": 17,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/17.png"
            },
            {
                "type": 3,
                "id": 16,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/16.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/Sammvioo",
        "viewAll": false,
        "layout": "full",
        "bgColor": "#000000",
        "group": 7,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xa25c075e971fadeb266d6f24ffc7864d476a9624/bsc",
        "descEn": "Clock",
        "descZh": "时钟",
        "titleZh": "时钟",
        "titleEn": "Clock",
        "nfts": [
            {
                "type": 1,
                "id": 20,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/20.png"
            },
            {
                "type": 2,
                "id": 21,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/21.png"
            },
            {
                "type": 3,
                "id": 19,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/19.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/Dino0527",
        "viewAll": true,
        "layout": "four",
        "bgColor": "#000000",
        "group": 8,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xbb781d9e8c73dccdc9c70d27ef2a2bcd88fa78e9/bsc",
        "descEn": "Metaverse Adventure with Duck Duck，Duck rush!",
        "descZh": "和鸭鸭一起元宇宙冒险，冲鸭！",
        "titleZh": "黄仔鸭，冲鸭！",
        "titleEn": "Yellow Duck",
        "nfts": [
            {
                "type": 1,
                "id": 22,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/22.png"
            },
            {
                "type": 1,
                "id": 23,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/23.png"
            },
            {
                "type": 2,
                "id": 24,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/24.png"
            },
            {
                "type": 3,
                "id": 25,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/25.png"
            }
        ]
    },
    {
        "twitter": "https://twitter.com/acedaluo",
        "viewAll": true,
        "layout": "left",
        "bgColor": "#000000",
        "group": 9,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x01a45b15081d7e9402fb889a153a32682b53a649/bsc",
        "descEn": "Wu Zetian's Rougamo - Xi'an Culture",
        "descZh": "武则天肉夹馍-西安文化",
        "titleZh": "武则天肉夹馍-西安文化",
        "titleEn": "Wu Zetian's Rougamo - Xi'an Culture",
        "nfts": [
            {
                "type": 1,
                "id": 27,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/27.jpg"
            },
            {
                "type": 3,
                "id": 26,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/26.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/King0314King",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 10,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x6560e9494D46F14d907d360BF2B4Aa039b4840bc/bsc",
        "descEn": "It aims to inherit the classic elements of the 3600 Shang Dynasty culture, integrate the bronze pattern style, express the \"King\" style of the \"tiger\" yea# and present a lovely visual feeling with cute modeling expression, implying auspiciousness and beauty.",
        "descZh": "旨在传承3600年商代文化经典元素，融合青铜器纹样风格，表现“虎”年的“王”者风范，以萌态化的造型表现手法，呈现可爱的视觉感受，寓意吉祥美好。",
        "titleZh": "王",
        "titleEn": "KING",
        "nfts": [
            {
                "type": 1,
                "id": 30,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/30.jpg"
            },
            {
                "type": 2,
                "id": 29,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/29.jpg"
            },
            {
                "type": 3,
                "id": 28,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/28.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/pupubable3744",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 11,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x1b3dc1c72d64b55de415f7bfb0e620dd7cf610c4/bsc",
        "descEn": "There were people who gathered bricks for the Tower of Babel in pursuit of lofty heights and the unknown; now there are also people who fill in the curved surface and sing praises to the sand dunes. I hope you can have a surging enthusiasm, retain your true self, and assert your attitude. If silence is the world's response, breaking the silence is your response.",
        "descZh": "曾经有人为巴别塔聚砖，企求高远，寻找未知；如今也有人填平曲面，追颂沙丘。希望你能怀有一腔汹涌的热诚，保留真实的自我，申明自己的态度。如果沉默是世界的回应，打破沉默就是你的回应。",
        "titleZh": "沉默的大多数",
        "titleEn": "The silent majority",
        "nfts": [
            {
                "type": 1,
                "id": 32,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/32.jpg"
            },
            {
                "type": 2,
                "id": 33,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/33.jpg"
            },
            {
                "type": 3,
                "id": 31,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/31.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/Blockchain_Ravi",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 12,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xC4d7bBd797f80F363C37b13dCF9840fdcebDF916/bsc",
        "descEn": "I have created this Nft because I love sinchain catoon and this cartoon has very huge fan following in India.Almost 80% of Tv pr comes from sinchan.",
        "descZh": "我创作了这部 Nft 是因为我喜欢 shinchan 动画片，而且这部动画片在印度拥有非常多的粉丝。",
        "titleZh": "Sinchain World",
        "titleEn": "Sinchain World",
        "nfts": [
            {
                "type": 1,
                "id": 36,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/36.png"
            },
            {
                "type": 2,
                "id": 35,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/35.png"
            },
            {
                "type": 3,
                "id": 34,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/34.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/MetaverseCryp",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 13,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x4dc6d584601e3bb9e7f82afb4fd10b8d7528afdd/bsc",
        "descEn": "1 Asset Card (Shows Financial Independence), 2 Receive background (One TokenPocket wallet for all Crypto Needs), 3 Asset Card Avatar (Life is Good)",
        "descZh": "1 张资产卡（显示财务独立）2 接收后台（一个 TokenPocket 钱包满足所有加密需求）3 资产卡头像（生活美好）",
        "titleZh": "Life is Good",
        "titleEn": "Life is Good",
        "nfts": [
            {
                "type": 1,
                "id": 39,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/39.png"
            },
            {
                "type": 2,
                "id": 37,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/37.png"
            },
            {
                "type": 3,
                "id": 38,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/38.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/Sammvioo",
        "viewAll": false,
        "layout": "full",
        "bgColor": "#000000",
        "group": 14,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xa25c075e971fadeb266d6f24ffc7864d476a9624/bsc",
        "descEn": "Back to Mickey's world.",
        "descZh": "回到米奇的世界。",
        "titleZh": "Mickey",
        "titleEn": "Mickey",
        "nfts": [
            {
                "type": 1,
                "id": 41,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/41.png"
            },
            {
                "type": 2,
                "id": 40,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/40.png"
            },
            {
                "type": 3,
                "id": 42,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/42.png"
            }
        ]
    },
    {
        "twitter": "https://twitter.com/jintianchitu",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 15,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x2792a9e0c58af2239a0151a9647c9cf47ca4c75b/bsc",
        "descEn": "I photographed the city lights in the middle of the night on the plane.",
        "descZh": "我在飞机上拍摄了半夜的城市灯光。",
        "titleZh": "Night",
        "titleEn": "Night",
        "nfts": [
            {
                "type": 1,
                "id": 45,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/45.jpg"
            },
            {
                "type": 2,
                "id": 44,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/44.jpg"
            },
            {
                "type": 3,
                "id": 43,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/43.jpg"
            }
        ]
    },
    {
        "twitter": "https://twitter.com/nartosiwamton1",
        "viewAll": true,
        "layout": "single-height",
        "bgColor": "#000000",
        "group": 16,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xa5b185bcd2296dea67c53614a2517eaa7a79bc43/bsc",
        "descEn": "This NFT will bring prosperity and wealthy to its owner, 25 are lucky numbers in some South East Asia culture, with TokenPocket it will be lucky numbers for everyone. ",
        "descZh": "这个 NFT 会给它的主人带来繁荣和财富，25 是一些东南亚文化中的幸运数字，有了 TokenPocket 它将成为每个人的幸运数字。",
        "titleZh": "My Money Aquarium",
        "titleEn": "My Money Aquarium",
        "nfts": [
            {
                "type": 3,
                "id": 46,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/46.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/273236561",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 17,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x785c31b5b62f9473ced5d3e77591e5160768aa1c/bsc",
        "descEn": "This is an interesting design. The combination of the doge and the safe highlights the security of the virtual currency wallet.",
        "descZh": "这是一个有趣的设计。 doge和保险箱的结合凸显了虚拟货币钱包的安全性。",
        "titleZh": "Doge Box",
        "titleEn": "Doge Box",
        "nfts": [
            {
                "type": 1,
                "id": 48,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/48.png"
            },
            {
                "type": 2,
                "id": 49,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/49.png"
            },
            {
                "type": 3,
                "id": 47,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/47.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/wyne_png",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 18,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x80e59b78825085f5c38887e8ca97ec106ae6c61e/bsc",
        "descEn": "HOLD all my different chain tokens on TokenPocket!",
        "descZh": "在 TokenPocket 上持有我所有不同的链代币！",
        "titleZh": "hold-ing on TP-1",
        "titleEn": "hold-ing on TP-1",
        "nfts": [
            {
                "type": 1,
                "id": 50,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/50.jpg"
            },
            {
                "type": 2,
                "id": 51,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/51.jpg"
            },
            {
                "type": 3,
                "id": 52,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/52.jpg"
            }
        ]
    },
    {
        "twitter": "https://twitter.com/wyne_png",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 19,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x80e59b78825085f5c38887e8ca97ec106ae6c61e/bsc",
        "descEn": "HOLD all my different chain tokens on TokenPocket!",
        "descZh": "在 TokenPocket 上持有我所有不同的链代币！",
        "titleZh": "hold-ing on TP-2",
        "titleEn": "hold-ing on TP-2",
        "nfts": [
            {
                "type": 1,
                "id": 53,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/53.jpg"
            },
            {
                "type": 2,
                "id": 54,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/54.jpg"
            },
            {
                "type": 3,
                "id": 55,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/55.jpg"
            }
        ]
    },
    {
        "twitter": "https://twitter.com/wyne_png",
        "viewAll": true,
        "layout": "full",
        "bgColor": "#000000",
        "group": 20,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x80e59b78825085f5c38887e8ca97ec106ae6c61e/bsc",
        "descEn": "HOLD all my different chain tokens on TokenPocket!",
        "descZh": "在 TokenPocket 上持有我所有不同的链代币！",
        "titleZh": "hold-ing on TP-3",
        "titleEn": "hold-ing on TP-3",
        "nfts": [
            {
                "type": 1,
                "id": 56,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/56.jpg"
            },
            {
                "type": 2,
                "id": 57,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/57.jpg"
            },
            {
                "type": 3,
                "id": 58,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/58.jpg"
            }
        ]
    },
    {
        "twitter": "https://twitter.com/meelonseth",
        "viewAll": true,
        "layout": "single-width",
        "bgColor": "#000000",
        "group": 21,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xe093facc1a27b1f258a4fe14baa0c8c6302a32fe/bsc",
        "descEn": "Red light green wine——Lonely dog",
        "descZh": "灯红酒绿——孤独的狗。",
        "titleZh": "Lonely dog",
        "titleEn": "Lonely dog",
        "nfts": [
            {
                "type": 2,
                "id": 59,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/59.jpg"
            }
        ]
    },
    {
        "twitter": "https://twitter.com/dparianto1991",
        "viewAll": true,
        "layout": "left",
        "bgColor": "#000000",
        "group": 22,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x8e13fa1469ddcb7cadd1b2e566b1af36e5fc2408/bsc",
        "descEn": "Fist time uploaded in internet, this is originally dress pattern or we called \"batik\" from one of Village Chief in Nggrowo, East Mataram (Java). As you can seen, this legacy from my family and its have mystical value and give to us a good luck.",
        "descZh": "第一次在互联网上上传，这最初是服装图案，或者我们称之为“蜡染”，来自东马塔兰 (爪哇) Ngrowo 的一位村长。 如您所见，我家族的这份遗产及其具有神秘价值，并给我们带来了好运。",
        "titleZh": "Batik from Village Chief in Nggrowo",
        "titleEn": "Batik from Village Chief in Nggrowo",
        "nfts": [
            {
                "type": 2,
                "id": 61,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/61.jpg"
            },
            {
                "type": 3,
                "id": 60,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/60.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/rr220895",
        "viewAll": true,
        "layout": "left",
        "bgColor": "#000000",
        "group": 23,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x82cdc41af60c7a4f40a2a378e7b48eedca69213b/bsc",
        "descEn": "Special Skin For TokenPocket Event.",
        "descZh": "TokenPocket 活动特别皮肤。",
        "titleZh": "TP狐狸",
        "titleEn": "TP FOX",
        "nfts": [
            {
                "type": 3,
                "id": 62,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/62.jpg"
            },
            {
                "type": 3,
                "id": 63,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/63.png"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/airdrop_royal",
        "viewAll": true,
        "layout": "single-height",
        "bgColor": "#000000",
        "group": 24,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xcb2711f8844af0c36c7abbce55abd5c77bdf207f/bsc",
        "descEn": "A dog was very  famous by trending on social media video . But after some time all people forget him. A now dog forbidden by all people.",
        "descZh": "一条狗因在社交媒体视频上走红而出名。 但一段时间后，所有人都忘记了他。 现在被所有人禁止的狗。",
        "titleZh": "",
        "titleEn": "Golden dog forbidden",
        "nfts": [
            {
                "type": 1,
                "id": 64,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/64.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/nguyenvuituoi",
        "viewAll": true,
        "layout": "single-width",
        "bgColor": "#000000",
        "group": 25,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xe4303321b4be4e669968e5b8bff4cb4d43e83dc2/bsc",
        "descEn": "Smart investment, optimal profit, great experience with TokenPocket.",
        "descZh": "明智的投资，最佳的利润，TokenPocket 的丰富经验。",
        "titleZh": "TokenPocketSmart",
        "titleEn": "TokenPocketSmart",
        "nfts": [
            {
                "type": 2,
                "id": 65,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/65.jpg"
            },
        ]
    },
    {
        "twitter": "https://twitter.com/dienhobitha",
        "viewAll": true,
        "layout": "single-height",
        "bgColor": "#000000",
        "group": 26,
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x6A083882074252bE78dA9d2c39a815e9F701D507/bsc",
        "descEn": "My First NFT, maybe just simple and nothing special, but for me this big project",
        "descZh": "我的第一个NFT，也许很简单，没什么特别的，但对我来说这个大项目。",
        "titleZh": "Anime Lover",
        "titleEn": "Anime Lover",
        "nfts": [
            {
                "type": 1,
                "id": 66,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design-2/66.jpg"
            },
        ]
    },
]



export const MULTI_ABI = [
    {
        "constant": false,
        "inputs": [
            {
                "components": [
                    {
                        "name": "target",
                        "type": "address"
                    },
                    {
                        "name": "callData",
                        "type": "bytes"
                    }
                ],
                "name": "calls",
                "type": "tuple[]"
            }
        ],
        "name": "aggregate",
        "outputs": [
            {
                "name": "blockNumber",
                "type": "uint256"
            },
            {
                "name": "returnData",
                "type": "bytes[]"
            }
        ],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }
]

export const ABI = [
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start_",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end_",
                "type": "uint256"
            },
            {
                "internalType": "string",
                "name": "uri_",
                "type": "string"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "tokenIds",
                "type": "uint256[]"
            }
        ],
        "name": "mint",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "payAmount",
                "type": "uint256"
            }
        ],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "group",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            }
        ],
        "name": "Mint",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "amounts",
                "type": "uint256[]"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "safeBatchTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "uri_",
                "type": "string"
            }
        ],
        "name": "setBaseURI",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "tokenIds_",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "groups_",
                "type": "uint256[]"
            }
        ],
        "name": "setGroup",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "price_",
                "type": "uint256"
            }
        ],
        "name": "setPrice",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "oldPrice",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newPrice",
                "type": "uint256"
            }
        ],
        "name": "SetPrice",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "oldStart",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newStart",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "oldEnd",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newEnd",
                "type": "uint256"
            }
        ],
        "name": "SetStartTime",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start_",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end_",
                "type": "uint256"
            }
        ],
        "name": "setTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            },
            {
                "indexed": false,
                "internalType": "uint256[]",
                "name": "values",
                "type": "uint256[]"
            }
        ],
        "name": "TransferBatch",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "TransferSingle",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "string",
                "name": "value",
                "type": "string"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            }
        ],
        "name": "URI",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "tokens",
                "type": "address[]"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "withdrawTokens",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "accounts",
                "type": "address[]"
            },
            {
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            }
        ],
        "name": "balanceOfBatch",
        "outputs": [
            {
                "internalType": "uint256[]",
                "name": "",
                "type": "uint256[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "end_time",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "groups",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "groupTotalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mint_price",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "start_time",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bytes4",
                "name": "interfaceId",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "totalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "uri",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
];